export const axiosData = {
  getOperatorOrDelivery: {
    url: '/api/admin/users?role=selectedRole&offset=offsetNum&limit=20',
    method: 'get',
  },
};
